import React, { useState, useEffect } from 'react';
import { signIn } from '../firebase/auth';

const Login: React.FC = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  // Debug log to show current error state
  console.log('Current error state:', error);

  // Track error state changes
  useEffect(() => {
    console.log('Error state changed to:', error);
  }, [error]);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted'); // Debug log
    setLoading(true);
    setError('');

    try {
      console.log('Attempting sign in...'); // Debug log
      await signIn(email, password);
      console.log('Sign in successful'); // Debug log
    } catch (error: any) {
      console.log('Login error:', error.message); // Debug log
      console.log('Full error:', error); // Debug log
      
      let errorMessage = '';
      // Handle specific IP conflict errors
      if (error.message.includes('IP address is already being used by another account')) {
        errorMessage = 'Bu cihaz zaten başka bir hesap tarafından kullanılıyor. Lütfen 12 saat bekleyin veya bu bir hata ise destek ile iletişime geçin.';
      } else if (error.message.includes('Unable to determine IP address')) {
        errorMessage = 'Konumunuz doğrulanamıyor. Lütfen internet bağlantınızı kontrol edin ve tekrar deneyin.';
      } else {
        // Generic error message for all other Firebase auth errors
        errorMessage = 'Giriş yapılamadı. Lütfen bilgilerinizi kontrol edin veya yöneticinizle iletişime geçin.';
      }
      
      console.log('Setting error message:', errorMessage); // Debug log
      setError(errorMessage);
      console.log('Error state after setError:', errorMessage); // Debug log
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <div className="flex justify-center mb-6">
            <img 
              src="https://meconyapi.com/clients/logo-mecon.png" 
              alt="Mecon Logo" 
              className="h-32 w-auto max-w-xs"
            />
          </div>
          
          <p className="mt-2 text-center text-sm text-gray-600">
            Personel Giriş Sistemi
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="email" className="sr-only">
                E-posta adresi
              </label>
              <input
                id="email"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm"
                placeholder="E-posta adresi"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <label htmlFor="password" className="sr-only">
                Şifre
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-b-md focus:outline-none focus:ring-primary-500 focus:border-primary-500 focus:z-10 sm:text-sm"
                placeholder="Şifre"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded text-sm text-center">
              <strong>Hata:</strong> {error}
            </div>
          )}

          {/* Debug: Always show error state */}
          

          <div>
            <button
              type="submit"
              disabled={loading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-primary-600 hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Giriş yapılıyor...' : 'Giriş Yap'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login; 